import type { JwtPayload } from "../jwt/JwtPayload"
import { getUserManagedMarketplaces } from "../jwt/marketplaceClaims"
import { hasPpnRole } from "./hasPpnRole"

export const isLocalDealerManager = (groups: string) => hasPpnRole(groups, "local_dealer_manager")
export const isLocalDealerViewer = (groups: string) => hasPpnRole(groups, "local_dealer_viewer")
export const isLocalMarketManager = (groups: string) => hasPpnRole(groups, "local_market_manager")
export const isLocalMarketManagerWithManagedMarketplaces = (claims: JwtPayload) => {
	const userManagedMarketplaces = getUserManagedMarketplaces(claims)
	return isLocalMarketManager(claims["ppn:groups"]) && !!userManagedMarketplaces && userManagedMarketplaces.length > 0
}
export const isLocalMarketNewsReviewer = (groups: string) => hasPpnRole(groups, "local_market_news_reviewer")
export const isLocalMarketViewer = (groups: string) => hasPpnRole(groups, "local_market_viewer")
export const isLocalMarketManagerOrViewer = (groups: string) =>
	isLocalMarketManager(groups) || isLocalMarketViewer(groups)
export const isLocalMediaManager = (groups: string) => hasPpnRole(groups, "local_media_manager")
export const isGlobalInventoryManager = (groups: string) => hasPpnRole(groups, "global_inventory_manager")
export const isGlobalInventoryViewer = (groups: string) => hasPpnRole(groups, "global_inventory_viewer")
export const isApplicationManager = (groups: string) => hasPpnRole(groups, "application_manager_dealer")
export const isLocalSalesManager = (groups: string) => hasPpnRole(groups, "local_sales_manager")

export const isDealerUser = (claims: JwtPayload) => {
	const groups = claims["ppn:groups"]
	return isLocalDealerManager(groups) && !isLocalMarketManagerWithManagedMarketplaces(claims)
}

export const isGlobalManager = (groups: string) => isApplicationManager(groups) || isGlobalInventoryManager(groups)

export const isMarketManager = (claims: JwtPayload) =>
	isGlobalManager(claims["ppn:groups"]) || isLocalMarketManagerWithManagedMarketplaces(claims)

export const hasMarketOrGlobalScope = (claims: JwtPayload) => {
	const groups = claims["ppn:groups"]
	return (
		isGlobalManager(groups) ||
		isGlobalInventoryViewer(groups) ||
		isLocalMarketManagerWithManagedMarketplaces(claims) ||
		isLocalMarketViewer(groups)
	)
}

export const isManager = (claims: JwtPayload) => isDealerUser(claims) || isMarketManager(claims)

export const isViewer = (claims: JwtPayload) => {
	const groups = claims["ppn:groups"]
	return (
		(isLocalDealerViewer(groups) || isGlobalInventoryViewer(groups) || isLocalMarketViewer(groups)) &&
		!isManager(claims)
	)
}
